import React, { useEffect, useState } from "react";
import { Badge, Text, Tooltip, Toggle, Link } from "@merge-api/merge-javascript-shared";
import ConfigurationSettingsCard from "../link/helpers/ConfigurationSettingsCard";
import { BILLING_PATH, SFTP_HELP_PAGE_PATH } from "../../../../router/RouterUtils";
import { SectionHeaderWrapper } from "../../../shared/SectionHeaderWrapper";
import useAppContext from "../../../context/useAppContext";
import { fetchWithAuth } from "../../../../api-client/APIClient";
import { showErrorToast, showSuccessToast } from "../../../shared/Toasts";

const SFTPTogglePage = () => {
  const { user } = useAppContext();
  const [isSFTPEnabledInLink, setIsSFTPEnabledInLink] = useState(false);
  const isSFTPEnabledForOrganization =
    user.organization.organization_billing_plan?.product_restrictions?.is_sftp_enabled;

  useEffect(() => {
    fetchWithAuth({
      path: `integrations/sftp-toggle`,
      method: "GET",
      onResponse: (response) => {
        setIsSFTPEnabledInLink(response.show_sftp ?? false);
      },
    });
  }, []);

  const handleStatusToggle = (state: boolean) => {
    fetchWithAuth({
      path: `integrations/sftp-toggle`,
      method: "PATCH",
      body: { show_sftp: state },
      onResponse: () => {
        setIsSFTPEnabledInLink(state);
        showSuccessToast("Successfully saved changes to Merge Link!");
      },
      onError: () => {
        showErrorToast("Failed to save changes. Please try again.");
      },
    });
  };

  return (
    <SectionHeaderWrapper
      title={<div className="flex flex-row gap-3 items-center">SFTP</div>}
      subtitle="SFTP (Secure File Transfer Protocol) allows your users to securely transfer .csv reports between third-party data providers and Merge. With SFTP, data is encrypted during transfer, protecting sensitive information from unauthorized access. Currently, SFTP support is available for Workday, ADP, Hibob, and SAP."
      docsUrl={SFTP_HELP_PAGE_PATH}
    >
      <ConfigurationSettingsCard title="Show in Merge Link">
        <div className="flex flex-row justify-between">
          <Text>Allow your users to choose SFTP when connecting</Text>
          {isSFTPEnabledForOrganization ? (
            <Toggle
              checked={isSFTPEnabledInLink}
              label={isSFTPEnabledInLink ? "Enabled" : "Disabled"}
              onChange={() => {
                handleStatusToggle(!isSFTPEnabledInLink);
              }}
            />
          ) : (
            <Tooltip
              title={
                <>
                  <Link href={BILLING_PATH}>
                    <Text className="text-white underline">Upgrade your plan</Text>
                  </Link>
                  <Text> to use SFTP</Text>
                </>
              }
            >
              <Toggle
                disabled
                label="Disabled"
                onChange={() => {
                  handleStatusToggle(!isSFTPEnabledInLink);
                }}
              />
            </Tooltip>
          )}
        </div>
      </ConfigurationSettingsCard>
    </SectionHeaderWrapper>
  );
};

export default SFTPTogglePage;
